<template>
  <main id="content">
    <section class="pt-4 pb-4">
      <b-container style="max-width: 900px">
        <b-row>
          <b-col md="4">
            <SettingsNav />
          </b-col>
          <b-col md="8" data-aos="fade-down-left">
            <div>
              <div class="card card-body">
                <h2 class="h4 mb-3">My Invoices</h2>
                <div
                  v-if="loading1"
                  class="d-flex justify-content-center pt-5 pb-5 text-muted"
                >
                  <font-awesome-icon icon="sync" size="2x" spin />
                </div>
                <div v-else-if="invoices.length > 0">
                  <div
                    class="card card-body"
                    v-for="invoice in invoices"
                    :key="invoice.id"
                    data-aos="fade-left"
                  >
                    <b-row>
                      <!-- <b-col cols="6" md="4" class="mb-3">
												<div class="font-weight-bold">Invoice ID</div>
												<div>{{invoice.id}}</div>
                      </b-col>-->
                      <b-col cols="6" md="4" class="mb-3">
                        <div class="font-weight-bold">Period</div>
                        <div>
                          {{
                            new Date(
                              invoice.lines.data[0].period.start * 1000
                            ).toLocaleDateString("en-us", {
                              month: "short",
                              day: "numeric",
                              year: "numeric"
                            })
                          }}
                          to
                          {{
                            new Date(
                              invoice.lines.data[0].period.end * 1000
                            ).toLocaleDateString("en-us", {
                              month: "short",
                              day: "numeric",
                              year: "numeric"
                            })
                          }}
                        </div>
                      </b-col>
                      <b-col cols="6" md="4" class="mb-3">
                        <div class="font-weight-bold">Payment status</div>
                        <div style="text-transform: capitalize">
                          {{ invoice.status }}
                        </div>
                      </b-col>
                      <b-col cols="6" md="4" class="mb-3">
                        <div class="font-weight-bold">
                          <span v-if="invoice.status == 'paid'">Date paid</span>
                          <span v-else>Due date</span>
                        </div>
                        <div>
                          <span v-if="invoice.status == 'paid'">
                            {{
                              new Date(invoice.date * 1000).toLocaleDateString(
                                "en-us",
                                {
                                  month: "short",
                                  day: "numeric",
                                  year: "numeric"
                                }
                              )
                            }}
                          </span>
                          <span v-else>
                            {{
                              new Date(
                                invoice.due_date * 1000
                              ).toLocaleDateString("en-us", {
                                month: "short",
                                day: "numeric",
                                year: "numeric"
                              })
                            }}
                          </span>
                        </div>
                      </b-col>
                      <b-col cols="6" md="4" class="mb-3">
                        <div class="font-weight-bold">Total</div>
                        <div>
                          <span v-if="invoice.lines.data[0].amount / 100 == 0">
                            Free
                          </span>
                          <span v-else>
                            {{ invoice.currency.toUpperCase() }}
                            {{ invoice.lines.data[0].amount / 100 }}
                          </span>
                        </div>
                      </b-col>
                      <!-- <b-col cols="6" md="4" class="mb-3">
												<div class="font-weight-bold">Credits applied</div>
												<div>{{invoice.invoice.currency_code}}{{invoice.invoice.credits_applied / 100}}</div>
                      </b-col>-->
                      <b-col cols="6" md="4" class="mb-3">
                        <div class="font-weight-bold">Amount due</div>
                        <div>
                          <span v-if="invoice.amount_due / 100 == 0">
                            Free
                          </span>
                          <span v-else>
                            {{ invoice.currency.toUpperCase() }}
                            {{ invoice.amount_due / 100 }}
                          </span>
                        </div>
                      </b-col>
                    </b-row>
                    <div>
                      <b-btn
                        id="btnInvoiceDownloadButton"
                        @click="downloadInvoiceAsPdfFunction(invoice.id)"
                        variant="primary"
                        class="icon-left"
                      >
                        <font-awesome-icon icon="cloud-download-alt" />Download
                        PDF
                        <font-awesome-icon
                          v-if="downloadingInvoice === invoice.id"
                          class="ml-2"
                          icon="sync"
                          spin
                        />
                      </b-btn>
                    </div>
                  </div>
                </div>
                <div v-else class="text-center pt-4 pb-3 text-muted">
                  <div class="d-flex justify-content-center mb-3">
                    <font-awesome-icon icon="exclamation-triangle" size="3x" />
                  </div>
                  <div class="h5">You have no invoices</div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import { getUserInvoices, downloadInvoiceAsPdf } from "../modules/database";
import constants from "../modules/constants";
import SettingsNav from "../components/SettingsNav.vue";
export default {
  data: () => {
    return {
      newSubscription: "",
      plans: [],
      invoices: [],
      show: true,
      loading1: false,
      downloadingInvoice: ""
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      customer: "getCustomer"
    })
  },
  mounted() {
    this.listInvoices();
  },
  methods: {
    downloadInvoiceAsPdfFunction(id) {
      this.downloadingInvoice = id;
      downloadInvoiceAsPdf(id)
        .then(link => {
          if (link.error) {
            this.$root.toast(constants.errors.download_pdf_error);
          } else {
            window.location.href = link;
          }
        })
        .catch(() => {
          this.$root.toast(constants.errors.download_pdf_error);
        })
        .finally(() => {
          this.downloadingInvoice = "";
        });
    },
    listInvoices() {
      this.loading1 = true;
      getUserInvoices()
        .then(list => {
          this.invoices = list.data;
        })
        .finally(() => {
          this.loading1 = false;
        });
    }
  },
  components: {
    SettingsNav
  }
};
</script>
